import React from "react";

export function pasteInColumn<T>(
    e: React.ClipboardEvent<HTMLInputElement>,
    rowIndex: number,
    partial: (value: string) => Partial<T>,
    currentRows: T[],
    setData: (data: T[]) => void,
    emptyRow: () => T
) {
    const text = e.clipboardData.getData('text');
    const lines = text
        .trim()
        .split(text.includes('\n') ? '\n' : '\t')
        .map(t => t.replace('\r', ''));
    if (!text || text === '' || lines.length === 0) {
        return
    }

    const entries = new Array(Math.max(lines.length + rowIndex, currentRows.length))
        .fill(null)
        .map<T>((_, index) => {
            const merge = currentRows[index] ?? emptyRow()

            const lineIndex = index - rowIndex;
            if (lineIndex >= 0 && lineIndex < lines.length) {
                return {
                    ...merge,
                    ...partial(lines[lineIndex]!)
                }
            }

            return merge
        });
    setData(entries)
    e.preventDefault()
}
